import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import moment from "moment-timezone";

import Client from "../models/Client";
import OrganizationMembership from "../models/OrganizationMembership";
import WorkSession from "../models/WorkSession";

import clientManager from "./clientManager";
import organizationManager from "./organizationManager";
import projectManager from "./projectManager";
import systemComponent from "../components/systemComponent";
import taskManager from "./taskManager";

class WorkSessionManager extends Controller {
	constructor () {
		super("workSessionManager");
		this.remoteClassName = "work-session";
	}

	async checkOpenByUser () {
		//Dave.Warn: occhio che se ce n'è più di una (ok, dovrebbe essere impossibile) si rompe.
		var rd = NousCore.api.createRequest();

		return NousCore.api.send(`${this.remoteClassName}/check-open`, rd)
		.then(data => {
			// console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let remoteRunningWorkSession;
						
						if (data.items.length === 1) {
							remoteRunningWorkSession = new WorkSession(data.items[0]);
						}
						else {
							if (data.items.length > 0) {
								remoteRunningWorkSession = new WorkSession(data.items[data.items.length - 1]);
							}
							else {
								remoteRunningWorkSession = null;
							}
						}
						Shark.set({runningWorkSession: remoteRunningWorkSession});

						workSessionManager.emit("openWSChecked");
						return {
							data: remoteRunningWorkSession,
							error: null,
							requestedAction: "check-open",
							status: "ok",
						};
					}
					default:
						workSessionManager.emit("error", data.error);
						return {
							data: null,
							error: data.error,
							requestedAction: "check-open",
							status: "ko",
						};
				}
			}
		});
	}

	async getReport (statsFilters) {
		const rd = NousCore.api.createRequest({ item: {
			clientGuidList: statsFilters.selectedCustomerGuidList,
			clientGuid: statsFilters.clientGuid,
			endDate: statsFilters.periodEnd + " 23:59:59",
			startDate: statsFilters.periodStart + " 00:00:00",
			userGuid: statsFilters.userGuid,
			userGuidList: statsFilters.selectedUserGuidList,
		} });

		return NousCore.api.send(`${this.remoteClassName}/search`, rd)
		.then(async data => {
			// console.log({workSessionStats: data});
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const { currUser, organizationMembershipList } = Shark.get();
						let { organizationList } = Shark.get();

						if (!organizationList) {
							const organizationListResponse = await organizationManager.getListForCurrentUser();
							organizationList = organizationListResponse.data;
						}
						// console.log({organizationList});
						//Dave: qui devo tenere in consierazione il ruolo che currUser ha in ogni organization: solo se sono un PowerAdmin devo vedere il costo. 
						//const allUserMembershipList = await organizationMembershipManager.getListByOrganizationGuidList(organizationList.map(item => item.guid));
			
						const workSessionList = Shark.getInstanceList(WorkSession, data.items);
						const clientGuidSet = new Set();
						const projectGuidSet = new Set();
						const taskGuidSet = new Set();
						let projectReport = [];

						workSessionList.forEach(item => {
							clientGuidSet.add(item.clientGuid);
							taskGuidSet.add(item.taskGuid);
							projectGuidSet.add(item.projectGuid);
						});

						// console.log({clientGuidSet, taskGuidSet, projectGuidSet});

						workSessionList.sort((a, b) => {
							return a.startDate - b.startDate;
						});

						if (taskGuidSet.size > 0) {
							const taskGuidList = Array.from(taskGuidSet);
							const projectGuid = Array.from(projectGuidSet);
							const fullTaskListResponse = await taskManager.getByGuidList(taskGuidList);
							const fullTaskList = fullTaskListResponse.data;
							// console.log({fullTaskList, fullTaskListResponse});

							const reportTaskList = taskGuidList.map(taskGuid => {
								const task = fullTaskList.find(item => item.guid == taskGuid);
								
								if (task) {
									const workSessionListInternal = workSessionList.filter(item => item.taskGuid == taskGuid);
									task.workSessionList = workSessionListInternal;
								}

								return task;
							});
	
							const fullProjectListResponse = await projectManager.getByGuidList(projectGuid);
							const fullProjectList = fullProjectListResponse.data;
							// console.log({fullProjectList, fullProjectListResponse});

							const clientGuidList = new Set(fullProjectList.map(item => item.clientGuid));
							const organizationGuidList = new Set(fullProjectList.map(item => item.organizationGuid));

							const fullClientListResponse = await clientManager.getByGuidList(Array.from(clientGuidList));
							const fullClientList = Shark.getInstanceList(Client, fullClientListResponse.data.items);
							// console.log({fullClientList, fullClientListResponse});

							const projectList = projectGuid.map(projectGuid => {
								// if (projectGuid == 401) debugger
								const project = fullProjectList.find(item => item.guid == projectGuid);
								// const project = new Project(fullProjectList.find(item => item.guid == projectGuid));
								project.taskList = reportTaskList.filter(item => item.projectGuid == projectGuid);

								project.taskList.sort((a, b) => {
									if (a.name.toLowerCase() > b.name.toLowerCase()) {
										return 1;
									}
									else if (a.name.toLowerCase() < b.name.toLowerCase()) {
										return -1;
									}
								});

								return project;
							});

							let statsTotalDuration = 0;
							let statsTotalInternalCost = 0;
							let statsTotalExternalCost = 0;
							let statsTotalInvoiceValue = 0;

							if (organizationList.length > 0 && organizationMembershipList.length > 0) {
								projectReport = Array.from(organizationGuidList).map(organizationGuid => {
									const organization = Utils.safp(organizationList, "guid", organizationGuid);
									const myMembership =  Utils.safp(organizationMembershipList, "organizationGuid", organizationGuid);
									// return organization.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(myMembership?.role);

									organization.clientList = fullClientList.filter(client => client.organizationGuid === organizationGuid)
									.map(client => {
										client.projectList = projectList.filter(project => project.clientGuid == client.guid);
										systemComponent.sortByName(client.projectList);
										return client;
									});

									const projectWithoutClient = projectList.filter(item => item.organizationGuid === organizationGuid && item.clientGuid === "");

									if (projectWithoutClient.length > 0) {
										const noClient = new Client({
											name: "(Nessun cliente)",
										});
										noClient.projectList = projectWithoutClient;//.map(item => new Project(item));
										systemComponent.sortByName(noClient.projectList);
										organization.clientList.push(noClient);
									}

									organization.clientList.forEach(client => {
										let clientDurantion = 0;
										let clientInternalCost = 0;
										let clientExternalCost = 0;
										let clientInvoiceValue = 0;

										let clientWSCount = 0;
										let projectWSCount = 0;

										client.projectList.forEach(project => {
											let hasWrikeTask = false;

											project.taskList.forEach(task => {
												// if (projectIndex === 0) {
												// }
												task.__clientName = client.name;
												task.__clientGuid = client.guid;
												// if (taskIndex === 0) {
												// }
												task.__projectName = project.name;

												if (task.__isWrikeTask) {
													hasWrikeTask = true;
												}
												
												task.workSessionList.forEach(workSession => {
													workSession.__duration = workSession.getDuration(client);
													clientDurantion += workSession.__duration;
													clientWSCount++;
													projectWSCount++;
												});

												task.__duration = task.getDuration(client);
											});
											project.__duration = project.getDuration(client);
											project.__hasWrikeTask = hasWrikeTask;
											project.__wsCount = projectWSCount;
											projectWSCount = 0;

											clientInternalCost += project.__internalCost;
											clientExternalCost += project.__externalCost;
											clientInvoiceValue += project.__invoiceValue;
										});

										organization.__showMoneyValues = organization.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_POWER_ADMIN].includes(myMembership?.role);

										client.__wsCount = clientWSCount;
										clientWSCount = 0;

										client.totalDuration = clientDurantion;
										client.totalDurationLabel = moment.duration(clientDurantion).format("HH:mm:ss", { trim: false });
										client.totalInternalCostLabel = Shark.$store.moneyFormatter.format(clientInternalCost);
										client.totalExternalCostLabel = Shark.$store.moneyFormatter.format(clientExternalCost);
										client.totalInvoiceValueLabel = Shark.$store.moneyFormatter.format(clientInvoiceValue);

										statsTotalDuration += clientDurantion;

										//Dave: Serve un conteggio dei totali anche per Organizzazione

										if (organization.__showMoneyValues) {
											statsTotalInternalCost += clientInternalCost;
											statsTotalExternalCost += clientExternalCost;
											statsTotalInvoiceValue += clientInvoiceValue;
										}
									});
		
									systemComponent.sortByName(organization.clientList);

									return organization;
								});
					
								systemComponent.sortByName(projectReport);
							}
							else if (currUser.__isSubscriptionStarter) {
								// return organization.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_POWER_ADMIN, OrganizationMembership.ROLE_POWER_USER].includes(myMembership?.role);
				
								const projectWithoutClient = projectList.filter(item => item.clientGuid === "");

								const noClient = new Client({
									name: "(Nessun cliente)",
								});

								if (projectWithoutClient.length > 0) {
									noClient.projectList = projectWithoutClient;//.map(item => new Project(item));
									systemComponent.sortByName(noClient.projectList);
								}

								let clientDurantion = 0;
								let clientInternalCost = 0;
								let clientExternalCost = 0;
								let clientInvoiceValue = 0;

								let clientWSCount = 0;
								let projectWSCount = 0;

								noClient.projectList.forEach(project => {
									let hasWrikeTask = false;

									project.taskList.forEach(task => {
										task.__projectName = project.name;

										if (task.__isWrikeTask) {
											hasWrikeTask = true;
										}
										
										task.workSessionList.forEach(workSession => {
											// workSession.__duration = workSession.getDuration(client);
											clientDurantion += workSession.__duration;
											clientWSCount++;
											projectWSCount++;
										});

										// task.__duration = task.getDuration(client);
									});
									// project.__duration = project.getDuration(client);
									project.__hasWrikeTask = hasWrikeTask;
									project.__wsCount = projectWSCount;
									projectWSCount = 0;

									clientInternalCost += project.__internalCost;
									clientExternalCost += project.__externalCost;
									clientInvoiceValue += project.__invoiceValue;
								});

								// organization.__showMoneyValues = organization.ownerGuid === currUser.guid || [OrganizationMembership.ROLE_POWER_ADMIN].includes(myMembership?.role);

								// client.__wsCount = clientWSCount;
								// clientWSCount = 0;

								// client.totalDuration = clientDurantion;
								// client.totalDurationLabel = moment.duration(clientDurantion).format("HH:mm:ss", { trim: false });
								// client.totalInternalCostLabel = Shark.$store.moneyFormatter.format(clientInternalCost);
								// client.totalExternalCostLabel = Shark.$store.moneyFormatter.format(clientExternalCost);
								// client.totalInvoiceValueLabel = Shark.$store.moneyFormatter.format(clientInvoiceValue);

								statsTotalDuration += clientDurantion;
			
								projectReport = { clientList: noClient};

								//Dave: Serve un conteggio dei totali anche per Organizzazione

								// if (organization.__showMoneyValues) {
								// 	statsTotalInternalCost += clientInternalCost;
								// 	statsTotalExternalCost += clientExternalCost;
								// 	statsTotalInvoiceValue += clientInvoiceValue;
								// }
	
								// systemComponent.sortByName(organization.clientList);

				
							// systemComponent.sortByName(projectReport);
							}

							workSessionList.forEach(item => {
								item.parseProjectName(fullProjectList);
								item.parseTaskName(fullTaskList);
								item.parseActivityColor(fullProjectList, organizationList);
								item.parseClientName(fullClientList);
								item.clean();
							});

							Shark.set({
								fullClientList,
								fullProjectList,
								fullTaskList,
								fullWorkSessionList: workSessionList,
								projectReport,
								statsTotalDurationLabel: moment.duration(statsTotalDuration).format("HH:mm:ss", { trim: false }),
								statsTotalExternalCostLabel: Shark.$store.moneyFormatter.format(statsTotalExternalCost),
								statsTotalInvoiceValueLabel: Shark.$store.moneyFormatter.format(statsTotalInvoiceValue),
								statsTotalInternalCostLabel: Shark.$store.moneyFormatter.format(statsTotalInternalCost),
							});

							return {
								data: projectReport,
								status: "ok"
							};
						}
						else {
							Shark.set({
								fullTaskList: [],
								fullWorkSessionList: [],
								projectReport,
								statsTotalDurationLabel: "",
								statsTotalExternalCostLabel: "",
								statsTotalInvoiceValueLabel: "",
								statsTotalInternalCostLabel: "",
							});
			
							return {
								data: projectReport,
								status: "ok"
							};
						}
					}
					// break;
					default:
						return {
							data: null,
							status: "ko"
						};
				}
			}
		});
	}

	saveDescription (workSession) {
		workSession = workSession || Shark.get("currWorkSession");
		var rd = NousCore.api.createRequest({ item: workSession.export() });

		return NousCore.api.send("work-session/update", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						workSession.import(data.items[0]);
						workSession.clean();

						workSessionManager.emit("descriptionSaved");
						return {
							data: workSession,
							error: null,
							requestedAction: "update",
							status: "ok",
						};
					default:
						workSessionManager.emit("error", data.error);
						return {
							data: null,
							error: data.error,
							requestedAction: "update",
							status: "ko",
						};
				}
			}
		});
	}

	save (workSession) {
		const rd = NousCore.api.createRequest({ item: workSession.export() });
		const action = workSession.guid === "" ? "insert" : "update";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						workSession.import(data.items[0]);
						workSession.clean();

						return {
							data: workSession,
							error: null,
							requestedAction: action,
							status: "ok",
						};
					default:
						return {
							data: null,
							error: data.error,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}
	
	saveStartTime (workSession) {
		const rd = NousCore.api.createRequest({ item: workSession.export() });
		const action = "save-start-time";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						workSession.import(data.items[0]);
						workSession.clean();

						return {
							data: workSession,
							error: null,
							requestedAction: action,
							status: "ok",
						};
					default:
						return {
							data: null,
							error: data.error,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	start (workSession) {
		var rd = NousCore.api.createRequest({ item: workSession.export() });

		return NousCore.api.send("work-session/insert", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						// Shark.get("currWorkSession").import(data.items[0]);
						workSession.import(data.items[0]);
						workSession.clean();

						workSessionManager.emit("started");
						return {
							data: workSession,
							error: null,
							requestedAction: "insert",
							status: "ok",
						};
					default:
						workSessionManager.emit("error", data.error);
						return {
							data: null,
							error: data.error,
							requestedAction: "insert",
							status: "ko",
						};
				}
			}
		});
	}

	stop (workSession) {
		const rd = NousCore.api.createRequest({ item: workSession.export() });
		const requestedAction = "update";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						workSessionManager.emit("stopped");
						return {
							data: workSession,
							error: null,
							requestedAction,
							status: "ok",
						};
					default:
						workSessionManager.emit("error", data.error);
						return {
							data: null,
							error: data.error,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const workSessionManager = new WorkSessionManager();

Shark.registerController(workSessionManager);

export default workSessionManager;